import React, { memo, useCallback } from "react";
import { useTracker } from "@dpdgroupuk/react-event-tracker";

import { useHistory } from "react-router-dom";
import { stringifyQuery, paramsToArray } from "../../utils/query";
import FilterPanel from "../../components/RouteFilter";
import { FilterTypes } from "../../models/route";
import useLocationQueryParams from "../../hooks/useLocationQueryParams";
import { FILTERS, STATUS_FILTER } from "../../constants/analytics";
import { ALL } from "../../constants/strings";

const RouteFilter = () => {
  const query = useLocationQueryParams();
  const filters = useLocationQueryParams({ parseNumbers: true });
  const history = useHistory();
  const filter = paramsToArray(filters, Object.values(FilterTypes));
  const tracker = useTracker();

  const handleClickFilterPanelButton = useCallback(
    (isOpen) => {
      tracker.logEvent(
        FILTERS[isOpen ? "SELECT_HIDE_FILTERS" : "SELECT_SHOW_FILTERS"]
      );
    },
    [tracker]
  );

  const handleOnChangeFilter = useCallback(
    (field, label, values) => {
      const newQuery = query;
      const isAll = label === ALL;

      if (isAll) {
        delete newQuery[field];
      } else {
        newQuery[field] = values;
      }

      history.push({
        search: stringifyQuery(newQuery),
      });

      tracker.logEvent({
        actionId: STATUS_FILTER[field][(isAll && "all") || "single"],
        value: label,
      });
    },
    [query, tracker]
  );

  const handleOnLoad = useCallback(() => {
    tracker.logEvent(FILTERS.LOAD);
  }, [tracker]);

  return (
    <FilterPanel
      filter={filter}
      detailVisible={query.detailVisible}
      onChange={handleOnChangeFilter}
      onClickFilterPanelButton={handleClickFilterPanelButton}
      onLoad={handleOnLoad}
    />
  );
};

export default memo(RouteFilter);
